import { useState, useEffect } from 'react';
import { Button, Modal, Form, Spinner, Row, Col } from 'react-bootstrap';

import { InformationModal, ProfileIconsModal } from 'Components/Common/Modal';
import { Input } from 'Components/Common/Form';
import { Users } from 'Services';

// Images
import IconCamera from 'Assets/images/icons/camera.png';
import IconProfile from 'Assets/images/profile.png';

// Validation
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './validation';

export default (props) => {
  const { profileDetails, userId } = props;
  const [showIcons, setShowIcons] = useState(false);
  const [updatedProfile, setUpdatedProfile] = useState('');

  const handleSubmit = async (values) => {
    try {
      if (updatedProfile) values.avatar_url = updatedProfile;
      await Users.updateProfileDetails(userId, values);
      InformationModal('Profile has been updated!');
      props.onUpdateProfile();
    } catch (error) {
      console.error(error);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues(profileDetails),
    onSubmit: handleSubmit,
    validationSchema,
  });

  useEffect(() => {
    setUpdatedProfile(profileDetails.avatar_url);
  }, [profileDetails.avatar_url]);

  return (
    <Modal size="md" centered className="edit-profile-modal" animation={false} {...props}>
      <Modal.Header closeButton>
        <Modal.Title />
      </Modal.Header>
      <Modal.Body>
        <div className="color-white mt-3">
          <div>Edit Profile</div>
          <b>Enter your details</b>
        </div>

        <Form onSubmit={formik.handleSubmit}>
          <Row>
            <Col>
              <div className="img-profile" role="button" tabIndex={0}>
                <img src={updatedProfile || IconProfile} alt="icon" height={100} width={100} className="profile" />
                <img src={IconCamera} alt="icon" className="icon-camera" onClick={() => setShowIcons(true)} />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Input label="First Name *" type="text" placeholder="First name" {...formik.getFieldProps('firstName')} />
              {formik.touched.firstName && formik.errors.firstName ? <div className="form-error">{formik.errors.firstName}</div> : null}
            </Col>
            <Col md={6}>
              <Input label="Last Name *" type="text" placeholder="Last name" {...formik.getFieldProps('lastName')} />
              {formik.touched.lastName && formik.errors.lastName ? <div className="form-error">{formik.errors.lastName}</div> : null}
            </Col>
          </Row>

          <Input label="Email Address" type="email" placeholder="Enter your email id" value={profileDetails.email || ''} disabled />

          <Form.Group className="mb-4">
            <Form.Label>Phone Number *</Form.Label>
            <Form.Control type="text" placeholder="(541) 754-3010" {...formik.getFieldProps('phoneNumber')} />
          </Form.Group>
          {formik.touched.phoneNumber && formik.errors.phoneNumber ? <div className="form-error">{formik.errors.phoneNumber}</div> : null}

          <div className="text-center">
            <Button className="mt-2" type="submit" disabled={formik.isSubmitting}>
              Update {formik.isSubmitting && <Spinner animation="border" size="sm" className="ml-2" />}
            </Button>
          </div>
        </Form>
      </Modal.Body>
      <ProfileIconsModal show={showIcons} onHide={() => setShowIcons(false)} setUpdatedProfile={setUpdatedProfile} />
    </Modal>
  );
};
